<div class="container-fluid p-4">
  <h3>Maintain Business</h3>
  <div>
    <mat-button-toggle-group name="view" [(ngModel)]="tab" (change)="onToggleView()" required>
      <mat-button-toggle [value]="TABS.BUSINESS">Business View</mat-button-toggle>
      <mat-button-toggle [value]="TABS.BRANCH">Branch View</mat-button-toggle>
      <mat-button-toggle [value]="TABS.LICENSE">License View</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div class="d-flex gap-3 my-3 justify-content-between">
    <mat-form-field subscriptSizing="dynamic" style="width: 450px">
      <mat-label>Search</mat-label>
      <input matInput type="text" placeholder="Search" [ngModel]="searchText()" (ngModelChange)="searchText.set($event)" />
      @if (searchText()) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="searchText.set('')">⨉</button>
      }
    </mat-form-field>
  @if (isBoss()) {
    <div class="d-flex gap-2">
      <!-- <button class="btn btn-light" (click)="addLicense()"><i class="fas fa-plus"></i> License</button> -->
      <button class="btn btn-light" (click)="addBusinessBranch()"><i class="fas fa-plus"></i> Branch License</button>
      <button class="btn btn-primary" (click)="addBusiness()"><i class="fas fa-plus"></i> Business</button>
    </div>
  }
  </div>
@switch (tab()) {
  @case (TABS.BUSINESS) {
    <app-business-list [faList]="faList()" [searchText]="searchText()" (showBranchOfBusiness)="showBranchOfBusiness($event)"></app-business-list>
  }
  @case (TABS.BRANCH) {
    <app-business-branch-list [companyList]="companyList()" [searchText]="searchText()" (showLicenseOfBusinessBranch)="showLicenseOfBusinessBranch($event.name, $event.branchId)"></app-business-branch-list>
  }
  @case (TABS.LICENSE) {
    <app-license-list [searchText]="searchText()" [(branchIdFilter)]="branchIdFilter"></app-license-list>  
  }
}
</div>
